import { MapPin, Phone, Mail, ArrowUpRight } from "lucide-react";

export const Footer = () => (
  <footer id="contact" data-testid="footer" className="relative border-t border-[#C85A32]/25 bg-[#1A120E] overflow-hidden">
    <div
      className="absolute inset-0 pointer-events-none"
      style={{ background: "radial-gradient(circle at 50% 110%, rgba(200,90,50,0.18) 0%, transparent 60%)" }}
    />
    <div className="relative max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-10">
      <p className="font-mono text-xs tracking-[0.3em] uppercase text-[#C85A32] mb-6 flex items-center gap-3">
        <span className="w-10 h-px bg-[#C85A32]" />
        07 // Dispatch
      </p>

      <h2 className="font-display font-bold tracking-tight leading-[0.95] text-[#F7F2EB] text-5xl sm:text-7xl lg:text-8xl mb-14">
        Let's move <span className="italic text-[#E89D4B]">it.</span>
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 border-t border-[#C85A32]/20 pt-10 mb-16">
        <div data-testid="footer-address" className="flex items-start gap-4">
          <span className="w-10 h-10 shrink-0 rounded-full border border-[#C85A32]/40 flex items-center justify-center text-[#E89D4B]">
            <MapPin size={16} />
          </span>
          <div>
            <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#E89D4B] mb-2">Headquarters</p>
            <p className="text-sm text-[#E6DACB]/85 leading-relaxed">
              4539 N 22nd St, Suite R<br />Phoenix, AZ 85016
            </p>
          </div>
        </div>
        <div className="flex items-start gap-4">
          <span className="w-10 h-10 shrink-0 rounded-full border border-[#C85A32]/40 flex items-center justify-center text-[#E89D4B]">
            <Phone size={16} />
          </span>
          <div>
            <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#E89D4B] mb-2">Dispatch Line</p>
            <a
              href="tel:+16026694590"
              data-testid="footer-phone-link"
              className="group flex items-center gap-1 text-sm text-[#E6DACB]/85 hover:text-[#E89D4B] transition-colors duration-300"
            >
              (602) 669-4590
              <ArrowUpRight size={12} className="opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </a>
          </div>
        </div>
        <div className="flex items-start gap-4">
          <span className="w-10 h-10 shrink-0 rounded-full border border-[#C85A32]/40 flex items-center justify-center text-[#E89D4B]">
            <Mail size={16} />
          </span>
          <div>
            <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#E89D4B] mb-2">Email</p>
            <a
              href="mailto:info@desertvalleyfreight.com"
              data-testid="footer-email-link"
              className="group flex items-center gap-1 text-sm text-[#E6DACB]/85 hover:text-[#E89D4B] transition-colors duration-300 break-all"
            >
              info@desertvalleyfreight.com
              <ArrowUpRight size={12} className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 shrink-0" />
            </a>
          </div>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-[#C85A32]/20 pt-8">
        <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#E6DACB]/45">
          © {new Date().getFullYear()} Desert Valley Freight LLC — Phoenix, Arizona
        </p>
        <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#E6DACB]/45">
          Dock-to-Door · Same-Day · Statewide
        </p>
        <a href="/admin" data-testid="footer-admin-link" className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#E6DACB]/45 hover:text-[#E89D4B] transition-colors duration-300">
          Dispatch Login
        </a>
      </div>
    </div>
  </footer>
);
